// extracted by mini-css-extract-plugin
module.exports = {"create-message":"message_create-message__36VyO","title":"message_title__1SDsM","text":"message_text__2tcB-","control":"message_control__3c68d","button":"message_button__2tFta"};